import { ServerSyncDataInterface } from '@shared/api';
import { DeepNullableExceptFor } from '@shared/utils';

export type UserStateInterface = DeepNullableExceptFor<
  ServerSyncDataInterface<Required<UserAppDataInterface>>,
  'team' | 'transfer' | 'deleteAccount',
  'appData'
>;

export interface UserAppDataInterface {
  table?: Record<string, Partial<UserAppDataTableInterface>>;
  newsReadIds?: number[];
  schemaVersion?: number;
  isSidebarClosed?: boolean;
  sidebarOpenedItems?: string[];
  theme?: ThemeEnum;
  locale?: string;
}

export interface UserAppDataTableInterface {
  isConfigFirstLoaded: boolean;
  itemsPerPageCount: number;
  sort: {
    colId: string;
    order: 'asc' | 'desc' | undefined;
  };
  pinnedIds: string[];
  columns: {
    ids: string[];
    entities: Record<string, UserAppDataTableColumnEntityInterface>;
  };
}

export interface UserAppDataTableColumnEntityInterface {
  pinned: boolean;
  width: number;
  hide: boolean;
}

export enum ThemeEnum {
  DARK = 'dark',
  LIGHT = 'light',
}
